/**
 * Remove duplicate project rows before rendering a board.
 *
 * Production data can contain more than one document for the same job when a
 * project_id slips past the unique index via invisible differences (trailing
 * whitespace, casing). Those render as identical duplicate rows AND — because
 * they collide on the React `key` — leave "ghost" rows behind when the list is
 * filtered/searched (a previous search's rows fail to unmount). Normalising the
 * project_id (trim + lowercase) and keeping the first occurrence fixes both.
 */
export const dedupeProjectsById = (projects) => {
  const seen = new Set();
  const out = [];
  for (const p of projects || []) {
    const raw = p && p.project_id != null ? String(p.project_id).trim().toLowerCase() : '';
    const key = raw || (p && p._id ? `id:${p._id}` : '');
    if (key && seen.has(key)) continue;
    if (key) seen.add(key);
    out.push(p);
  }
  return out;
};
